/** How far this hub's nested missions actually sit from it. */
export function nestFootprint(h, childrenOf, x, y) {
  let r = 0.85;
  walkNest(h, childrenOf, (i) => {
    r = Math.max(r, Math.hypot(x[i] - x[h], y[i] - y[h]) + 0.48);
  });
  return r;
}

export function walkNest(h, childrenOf, visit) {
  (childrenOf[h] || []).forEach((i) => {
    visit(i);
    walkNest(i, childrenOf, visit);
  });
}

export function shiftNest(h, childrenOf, x, y, dx, dy) {
  x[h] += dx;
  y[h] += dy;
  walkNest(h, childrenOf, (i) => {
    x[i] += dx;
    y[i] += dy;
  });
}

/**
 * Same-tag hubs share one cloud, but their nest rings should not melt into
 * one mass. A small pad between real footprints is enough.
 *
 * Root hubs only. A hub nested inside another nest already sits in its
 * parent's pod and moves with it (shiftNest walks the whole family). Pushing
 * it against its own parent would fling it — and its children — out of the
 * cluster, harder on every pass as the parent's footprint grows to include it.
 */
export function separateSameIslandNests({ hubs, childrenOf, clusterIndex, childCount, x, y, depthOf }) {
  const nestHubs = hubs.filter((h) => childCount[h] > 0 && (!depthOf || depthOf(h) === 0));
  if (nestHubs.length < 2) return;
  const PAD = 0.7;
  for (let pass = 0; pass < 16; pass += 1) {
    let moved = false;
    for (let a = 0; a < nestHubs.length; a += 1) {
      const i = nestHubs[a];
      for (let b = a + 1; b < nestHubs.length; b += 1) {
        const j = nestHubs[b];
        if (clusterIndex[i] !== clusterIndex[j]) continue;
        const ri = nestFootprint(i, childrenOf, x, y);
        const rj = nestFootprint(j, childrenOf, x, y);
        let dx = x[i] - x[j];
        let dy = y[i] - y[j];
        let dist = Math.hypot(dx, dy);
        const need = ri + rj + PAD;
        if (dist < 1e-4) { dx = 1; dy = 0; dist = 1; }
        if (dist >= need) continue;
        moved = true;
        const push = (need - dist) * 0.5;
        const ux = dx / dist;
        const uy = dy / dist;
        shiftNest(i, childrenOf, x, y, ux * push, uy * push);
        shiftNest(j, childrenOf, x, y, -ux * push, -uy * push);
      }
    }
    if (!moved) break;
  }
}

/** Grow the island hull only by how far a nest actually sticks out. */
export function nestOverflow(rs, childCount, podR, x, y, hullR) {
  let extra = 0;
  rs.forEach((i) => {
    if (!childCount[i]) return;
    extra = Math.max(extra, Math.hypot(x[i], y[i]) + podR[i] - hullR);
  });
  return extra > 0 ? extra + 0.35 : 0;
}
